import { PostCheckoutComponent } from './post-checkout/post-checkout.component'
import { NotFoundComponent } from './error/not-found.component'
import { OAuthCallbackComponent } from './components/oauth-callback.component'
import { AdminGuardService, AuthGuardService } from './services'
import { CardDownloadComponent } from './download/card-download.component'
import { VerifyComponent } from './verify/verify.component'
import { PostAssignmentsComponent } from './post-assignments/post-assignments.component'
import { SupportAdminGuardService } from './services/support-admin-guard.service'
import { Routes } from "@angular/router";

/**
 * used by Router to define application routes
 */
export const routes: Routes = [
  {
    path: 'not-found',
    component: NotFoundComponent,
    data: {
      title: 'Not found - SportsEngine Memberships',
    }
  },
  {
    path: 'download',
    component: CardDownloadComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Download card - SportsEngine Memberships',
    }
  },
  {
    path: 'download/:id',
    component: CardDownloadComponent,
    data: {
      title: 'Download card - SportsEngine Memberships',
    }
  },
  {
    path: 'invite',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./invite/invite.module').then(m => m.InviteModule)
  },
  {
    path: 'org',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./org/org.module').then(m => m.OrgModule)
  },
  {
    path: 'minor-token',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./minor-token/minor-token.module').then(m => m.MinorTokenModule)
  },
  {
    path: 'print-job',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./print-job/print-job.module').then(m => m.PrintJobModule)
  },
  {
    path: 'se-dashboard',
    canActivate: [AdminGuardService],
    loadChildren: () => import('./se-dashboard/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'support-dashboard',
    canActivate: [SupportAdminGuardService],
    loadChildren: () => import('./se-dashboard/support/support-dashboard.module').then(m => m.SupportDashboardModule)
  },
  {
    path: 'verify/:cardId',
    component: VerifyComponent
  },
  {
    path: 'waivers',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./electronic-documents/electronic-documents.module').then(m => m.ElectronicDocumentsModule)
  },
  {
    path: 'electronic_documents',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./electronic-documents/electronic-documents.module').then(m => m.ElectronicDocumentsModule)
  },
  {
    path: 'buy',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./buy/buy.module').then(m => m.BuyModule),
  },
  {
    path: 'obo',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./obo/obo.module').then(m => m.OboModule)
  },
  {
    path: 'buy/post-checkout/:saleNumber',
    component: PostCheckoutComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Your membership - SportsEngine Memberships',
    }
  },
  {
    path: 'post-checkout/:saleNumber',
    component: PostCheckoutComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Your membership - SportsEngine Memberships',
    }
  },
  {
    path: 'buy/post-assignment/:membershipId',
    component: PostCheckoutComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Your membership - SportsEngine Memberships',
    }
  },
  {
    path: 'post-assignment/:membershipId',
    component: PostCheckoutComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Your membership - SportsEngine Memberships',
    }
  },
  {
    path: 'post-assignments',
    component: PostAssignmentsComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Your membership - SportsEngine Memberships',
    }
  },
  {
    path: 'buy/oauth/callback',
    redirectTo: 'oauth/callback',
    pathMatch: 'full'
  },
  {
    path: 'oauth/callback',
    component: OAuthCallbackComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  },
]
